module.exports = __webpack_public_path__ + "img/ai.9b6a533a.png";